
const PanelData= [
  {
    question: `Do you have an innovation program, and if so, how long has it been running?`,
    radio: true,
    answers: [
      {
        text: `Yes - less than 1 year`,
        score: 1
      },
      {
        text: `Yes - between 1 and 3 years`,
        score: 2
      },
      {
        text: `Yes - between 3 and 5 years`,
        score: 3
      },
      {
        text: `Yes - between 5 and 7 years`,
        score: 3
      },
      {
        text: `Yes - more than 7 years`,
        score: 3
      },
      {
        text: `No`,
        score: 1,
        redirect: true
      }
    ]
  },
  {
    lead: `Ideation Programs`,
    question: `Please indicate the main business objective(s) for your innovation program.`,
    instruction: `(Select all that apply)`,
    answers: [
      {
        text: `Build a culture of innovation`,
        score: 1
      },
      {
        text: `Develop better products and services`,
        score: 3
      },
      {
        text: `Increase employee engagement in innovation`,
        score: 2
      },
      {
        text: `Build collaboration and creativity skills within our employees`,
        score: 2
      },
      {
        text: `Improve our existing innovation process`,
        score: 3
      },
      {
        text: `None`,
        score: 1
      }
    ]
  },
  {
    lead: `Ideation Implementation`,
    question: `Do you have a way of tracking and implementing ideas?`,
    radio: true,
    answers: [
      {
        text: `Yes`,
        score: 3
      },
      {
        text: `No`,
        score: 1
      },
      {
        text: `No - but we plan to in the near future`,
        score: 2
      },
      {
        text: `Yes - but it’s not optimized`,
        score: 3
      }
    ]
  },
  {
    lead: `Engagment`,
    question: `Who participates in your innovation program?`,
    instruction: `(Select all that apply)`,
    answers: [
      {
        text: `All employees`,
        score: 3
      },
      {
        text: `Partners`,
        score: 2
      },
      {
        text: `General public`,
        score: 2
      },
      {
        text: `Innovation or R&D team`,
        score: 2
      },
      {
        text: `All the above`,
        score: 1
      }
    ]
  },
  {
    lead: `Measuring Impact`,
    question: `How do you measure the value of your innovation program?`,
    radio: true,
    answers: [
      {
        text: `We don’t measure`,
        score: 1
      },
      {
        text: `We measure indirect value (e.g. Employee engagement)`,
        score: 2
      },
      {
        text: `We measure direct financial value (e.g. Reduced costs)`,
        score: 3
      },
      {
        text: `We measure both indirect and direct value`,
        score: 3
      }
    ]
  }
]
export default PanelData